<div class="tds-container-fluid">
    <div class="tds-row">
        <h2 class="tds-headline-02">Solicitações em Crítica</h2>
    </div>

    <div class="tds-row" *ngIf="(criticalRequests) as criticalRequestsResult">
        <tds-table *ngIf="criticalRequestsResult.length > 0" vertical-dividers="false" compact-design="false" responsive="true" no-min-width>
            <tds-table-header>
                <tds-header-cell (customOrder)="getAllCriticalRequests(page)" cell-key='action' cell-value='' sortable></tds-header-cell>
                <tds-header-cell (customOrder)="getAllCriticalRequests(page)" cell-key='coD_ORIGINAL' cell-value='Código' sortable></tds-header-cell>
                <tds-header-cell (customOrder)="getAllCriticalRequests(page)" cell-key='critica' cell-value='Crítica' sortable></tds-header-cell>
                <tds-header-cell (customOrder)="getAllCriticalRequests(page)" cell-key='descr' cell-value='Descrição' sortable></tds-header-cell>
                <tds-header-cell (customOrder)="getAllCriticalRequests(page)" cell-key='data' cell-value='Data' sortable></tds-header-cell>
            </tds-table-header>
            <tds-table-body>
                <tds-table-body-row *ngFor="let criticalRequest of criticalRequestsResult  | paginate: { id: 'criticalRequestP', itemsPerPage: 10, currentPage: page, totalItems: total}">
                    <tds-body-cell cell-key="actions">
                        <div class="action-buttons" title="Excluir">
                            <tds-icon id="edit" name="cross" size="20px" style="cursor: pointer; color: red;" (click)="confirmDelete(criticalRequest.id)"></tds-icon>
                        </div>
                    </tds-body-cell>
                    <tds-body-cell cell-key="coD_ORIGINAL">{{ criticalRequest.id }}</tds-body-cell>
                    <tds-body-cell cell-key="critica">{{ criticalRequest.critical }}</tds-body-cell>
                    <tds-body-cell cell-key="descr">{{ criticalRequest.description }}</tds-body-cell>
                    <tds-body-cell cell-key="data">{{ criticalRequest.releaseDate }}</tds-body-cell>
                </tds-table-body-row>
            </tds-table-body>
        </tds-table>
        <pagination-controls id="criticalRequestP" *ngIf="criticalRequestsResult.length > 0" previousLabel="Anterior"
        nextLabel="Próximo" (pageChange)="getAllCriticalRequests($event)"></pagination-controls>
    </div>
    

    
</div>